import { Component } from '@angular/core';
import {environment} from '../../../environments/environment';
import { Router } from '@angular/router';
import {AppConstants} from '../../shared/app-constants';

@Component({
  selector: 'app-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  expanded = true;
  footerLinks = environment.footerLinks;
  constructor(private readonly router: Router) {}

  onNavigateToPrivacy() {
    this.router.navigate(['/privacy-statement']);
  }

  onNavigateToTermsOfUse() {
    this.router.navigate(['/terms-of-use']);
  }

  onNavigateToFAQs() {
    this.router.navigate(['/faqs']);
  }

  onFooterToggle() {
    this.expanded = !this.expanded;
  }

  handleDropdownKey(event: any) {
    return AppConstants.handleDropdownKey(event);
  }

}
